/* eslint-disable */

<template>
  <div class="b-video-landing-container">
    <div :class="loading"></div>
    <div v-if="errorMessage">
      <h3 style="text-align: center">Error in fetching data, Please reload the page</h3>
    </div>
    <div style="{padding:15px}" v-else>
      <div class="b-video-landing-container__nav">
        <div
          class="b-video-landing-container__nav-tab"
          v-for="tab in tabs"
          :key="tab.name"
          v-on:click="changeCurrentTabHandler(tab.name)"
        >
          <div class="b-video-landing-container-heading__row">
            <h2 class="b-video-landing-container-heading">{{tab.name}}</h2>
            <div v-if="tab.totalCount !==null">
              <h2 class="b-video-landing-container-heading">({{tab.totalCount}})</h2>
            </div>
          </div>
          <div :class="{'b-skyc-landing-container__active': currentTab === tab.name }"></div>
          <!-- <h1 >KYC Details</h1> -->
        </div>
      </div>
      <div v-if="video_details.length>0">
        <table>
          <thead>
            <tr>
              <th>S.No</th>
              <th>Id</th>
              <th>Name</th>
              <th>PAN <input type="search" v-model="searchByPan" style="margin-left:10px;" placeholder="Search by PAN.." class="bordered"></th>
              <th>
                Created Date
                <a
                  href
                  v-on:click.stop.prevent="sortByDate('createdAt','desc')"
                  v-if="sortByCreatedDate===true"
                >
                  <span>
                    <img src="../../assets/sort_asc.png" class="b-video-landing-container__sort-icon" />
                  </span>
                </a>
                <a
                  href
                  v-on:click.stop.prevent="sortByDate('createdAt','asc')"
                  
                  v-else-if="sortByCreatedDate===false"
                >
                  <span>
                    <img
                      src="../../assets/sort_desc.svg"
                      class="b-video-landing-container__sort-icon"
                    />
                  </span>
                </a>
                <a href v-on:click.stop.prevent="sortByDate('createdAt','asc')" v-else>
                  <span>
                    <img
                      src="../../assets/sort_icon.svg"
                      class="b-video-landing-container__sort-icon"
                    />
                  </span>
                </a>
              </th>
              <th>
                Update Date
                <a
                  href
                  v-on:click.stop.prevent="sortByDate('updatedAt','desc')"
                  
                  v-if="sortByUpdatedDate===true"
                >
                  <span>
                    <img src="../../assets/sort_asc.png" class="b-video-landing-container__sort-icon" />
                  </span>
                </a>
                <a
                  href
                  v-on:click.stop.prevent="sortByDate('updatedAt','asc')"
                
                  v-else-if="sortByUpdatedDate===false"
                >
                  <span>
                    <img
                      src="../../assets/sort_desc.svg"
                      class="b-video-landing-container__sort-icon"
                    />
                  </span>
                </a>
                <a href v-on:click.stop.prevent="sortByDate('updatedAt','asc')" v-else>
                  <span>
                    <img
                      src="../../assets/sort_icon.svg"
                      class="b-video-landing-container__sort-icon"
                    />
                  </span>
                </a>
              </th>
              <th>Email id <input type="search" v-model="searchByEmail" style="margin-left:10px;" placeholder="Search by email.." class="bordered"></th>
              <th
                v-if="$route.params.status=='RejectedByAdmin' || $route.params.status=='RejectedByCVL'"
              >Error Message</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(video,index) in all_video" :key="video.id">
              <td>{{index+1}}</td>
              <td>
                <a href v-on:click.stop.prevent="videoIdDetail(video.id)">{{video.id}}</a>
              </td>
              <td>{{video.attributes.kyc_info.data.attributes.name}}</td>
              <td>{{video.attributes.kyc_info.data.attributes.PAN_number}}</td>
              <td>{{video.attributes.created_at | datetimeFormat}}</td>
              <td>{{video.attributes.updated_at | datetimeFormat}}</td>
              <td>{{video.attributes.kyc_info.data.attributes.email}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else class="b-video-not-found--msg">No record found</div>
    </div>
  </div>
</template>
<script>
import {  mapState } from "vuex";

import Moment from "moment";

export default {
  data() {
    return {
      video_details: [],
      loaded: false,
      videoDetails: null,
      filterFlag: false,
      createdDate_asc: null,
      updatedDate_asc: null,
      errorMessage: false,
      // tabs: ["Pending", "Submitted", "RejectedByAdmin", "RejectedByCVL"],
      tabs: [
        { name: "IpvVerificationPending", totalCount: null },
        // { name: "Submitted", totalCount: null },
        // { name: "RejectedByAdmin", totalCount: null },
        // { name: "RejectedByCVL", totalCount: null },
        // { name: "ConsentFormTrue", totalCount: null },
      ],
      currentTab: { name: "IpvVerificationPending", totalCount: null },
      allData: false,
      searchByPan: null,
      searchByEmail: null
    };
  },
  async mounted() {
    this.$store.commit("resetVideoTab");
    this.$store.commit('set_admin_partner', this.$route.params.partner)
    this.$store.commit('set_kyc_verification_type', 'video')
    await this.$store
      .dispatch("fetchVideoData", '')
      .then(() => {
        this.tabs[0].totalCount = this.videoData.length
        this.showVideoList();
      })
      .catch(err => {
        console.log("err",err)
        this.errorMessage = true});
  },
  methods: {

    videoIdDetail: function(id) {
      this.$store.commit("resetVideoTab")
      this.$router.push({ name: "video-details-id", params: { id: id , params: this.admin_partner} });
      this.$store.commit("removeUserDetails");
    },

    filterStatus(status) {
      this.filterFlag = true;
      this.video_details = this.video_details.filter(
        element => element.kyc_form_check_status === status
      );
    },
    removeFilter() {
      this.filterFlag = false;
      this.showVideoList();
    },
    showVideoList() {
      // console.log(this.$route.params);
      this.currentTab = this.$route.params.status;

      this.video_details = this.videoData;

      // switch (this.$route.params.status) {
      //   case "on_hold":
      //     // eslint-disable-next-line no-case-declarations
      //     let list = this.videoData.filter(
      //       element => element.attributes.video_verification_status === "on_hold"
      //     );
      //     list.sort((a,b)=> b.attributes.video_verification_status - a.attributes.video_verification_status)
      //     this.video_details = list
      //     break; 
      //   default:
      //     this.video_details = this.videoData;
      // }
  
    },

    showVideoData(type) {
      this.tabs[0].totalCount = 0;
      let route_param = this.$route.params.status;
      this.allData = true;

      if(type == 'on_hold') {
        route_param = "IpvVerificationPending";
        this.allData = false;
      }

      this.$store
        .dispatch(`fetchVideoData`, type)
          .then(() => {
            this.tabs[0].totalCount = this.videoData.length
            this.changeCurrentTabHandler(route_param);
            this.showVideoList();
          })
        .catch(err  => {
          console.log("err",err)
          this.errorMessage = true});
    },

    sortByDate(type, sortOrder) {
      let data = [...this.video_details];
      if (type === "createdAt") {
        // this.updatedDate_asc = null;
        this.$store.commit("setSortingByDate",{sortByUpdatedDate:null});
        if (sortOrder === "asc") {
          // this.createdDate_asc = true;
          this.$store.commit("setSortingByDate",{sortByCreatedDate:true});
          data.sort((a, b) => new Date(b[type]) - new Date(a[type]));
        } else {
          // this.createdDate_asc = false;
            this.$store.commit("setSortingByDate",{sortByCreatedDate:false});
          data.sort((a, b) => new Date(a[type]) - new Date(b[type]));
        }
      }
      if (type === "updatedAt") {
        // this.createdDate_asc = null;
          this.$store.commit("setSortingByDate",{sortByCreatedDate:null});
        if (sortOrder === "asc") {
          // this.updatedDate_asc = true;
          this.$store.commit("setSortingByDate",{sortByUpdatedDate:true});
          data.sort((a, b) => new Date(b[type]) - new Date(a[type]));
        } else {
          // this.updatedDate_asc = false;
          this.$store.commit("setSortingByDate",{sortByUpdatedDate:false});
          data.sort((a, b) => new Date(a[type]) - new Date(b[type]));
        }
      }

      this.video_details = data;
    },
    changeCurrentTabHandler(tab) {
      this.currentTab = tab;
      this.$router.replace({ name: 'video-details', params: {status: tab, partner: this.admin_partner}});
      this.showVideoList();
    },
    checkKycStatus(status){
         switch (status) {
            case "2":
              return 'Pending'
            case "4":
            case "5":
              return 'Submitted'
            case "3":
              return 'Rejected By Admin'
            case "6":
              return 'Rejected By CVL'
          }
    }
  },
  computed: {
    ...mapState({
      videoData: state => state.videoDetails.videoData,
      sortByCreatedDate: state => state.videoDetails.sortByCreatedDate,
      sortByUpdatedDate: state => state.videoDetails.sortByUpdatedDate,
      admin_partner: state => state.kycLogin.admin_partner,
      kyc_verification_type: state => state.kycLogin.kyc_verification_type
      
    }),
    getDetails() {
      return this.$store.state.videoDetails.videoData;
    },
    loading() {
      return {
        loader: this.$store.state.videoDetails.loading
      };
    },
    all_video() {
      if(this.searchByPan) {
        return this.video_details.filter(obj => {
                if(obj.attributes.kyc_info.data.attributes.PAN_number) {
                  return (obj.attributes.kyc_info.data.attributes.PAN_number.indexOf(this.searchByPan.toUpperCase()) > -1)
                } else {
                  return false;
                }
              });
      } else if(this.searchByEmail) {
        return this.video_details.filter(obj => {
                if(obj.attributes.kyc_info.data.attributes.email) {
                  return (obj.attributes.kyc_info.data.attributes.email.indexOf(this.searchByEmail) > -1)
                } else {
                  return false;
                }
              });
      } else {
        return this.video_details;
      }
    }
  },
  watch: {
    "$route.params.status": function(status) {
      this.currentTab = status;
      this.showVideoList();
    }
  },

  filters: {
    datetimeFormat: function(value) {
      if (value) {
        return Moment(value).format("DD/MM/YYYY");
      }
    },
    booleanFilter(value){
    return value? " YES ":" NO ";
    },

  },
};
</script>

<style scoped>
.b-video-landing-container {
  margin-top: 40px;
}
.b-video-landing-container-heading {
  text-align: center;
  margin-bottom: 8px;
  cursor: pointer;
}
.b-video-landing-container__nav {
  display: flex;
  justify-content: space-around;
  margin-bottom: 45px;
}
.b-skyc-landing-container__active {
  border: solid 1.5px #2b3d51;
}
tbody tr:hover {
  background-color: aliceblue;
}

table {
  text-align: center;
  border-collapse: collapse;
  width: 100%;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

.b-video-landing-container__sort-icon {
  width: 12px;
  height: 12px;
}
.b-video-not-found--msg {
  display: flex;
  justify-content: center;
}
.b-video-landing-container-heading__row {
  display: flex;
}
.b-video-rejected{
color: #ff0000
}
.b-video-data-link__active {
  text-decoration: none;
}

/* td a{
  text-decoration: none;
} */

/* Safari */
</style>